(async () => {
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "main-newsletter-popup",
    class extends e.default {
      async render() {
        await new Promise((e) => {
          window.theme.modalReady && e(),
            document.addEventListener("modalReady", e, {
              once: !0,
            });
        }),
          this._initPopup();
      }

      _initPopup() {
        var e, t;
        (this.daysToReAppear = this.getAttribute("days-to-re-appear")),
          (this.displayDelay = +this.getAttribute("display-delay")),
          (this.lastViewed = window.localStorage.getItem(
            "newsletterLastViewed"
          )),
          null === this.lastViewed &&
            (this._setLastViewed(), this._showPopup()),
          Date.now() >=
            ((e = this.lastViewed), (t = this.daysToReAppear), e + 864e5 * t) &&
            this._showPopup();
      }

      _setLastViewed() {
        (this.lastViewed = Date.now()),
          window.localStorage.setItem("newsletterLastViewed", this.lastViewed);
      }

      _showPopup() {
        0 === this.displayDelay
          ? this._trigerModal()
          : setTimeout(this._trigerModal.bind(this), 1e3 * this.displayDelay);
      }

      _trigerModal() {
        this.trigger("openPopup", {
          target: "#newsletterPopup",
        });
      }
    }
  );
})();
